import { EAbondancePeriphyton } from "./enum/abondance-periphyton"
import { EUniteUR1 } from "./enum/unite-ur1";
import { EUniteUR2 } from "./enum/unite-ur2";
import { IBMREclairement } from "./IBMR-eclairement";
import { IBMRFaciesEcoulement } from "./IBMR-facies-ecoulement";
import { IBMRProfondeur } from "./IBMR-profondeur";
import { IBMRSubstrat } from "./IBMR-substrat";
import { IBMRVegetationAquatique } from "./IBMR-vegetation-aquatique";
import { IBMRVitesseCourant } from "./IBMR-vitesse-courant";
import { Transect } from "./transect";

export class IBMRUniteReleve {
    Code: string;
    Recouvrement: number;
    Longueur: number;
    Largeur: number;
    SurfaceVegetalisee: number;
    AbondancePeriphyton: EAbondancePeriphyton;
    TypeUnite: EUniteUR1 | EUniteUR2;

    IBMRSubstrat: IBMRSubstrat = new IBMRSubstrat();
    IBMRProfondeur: IBMRProfondeur = new IBMRProfondeur();
    IBMRFaciesEcoulement: IBMRFaciesEcoulement = new IBMRFaciesEcoulement();
    IBMREclairement: IBMREclairement = new IBMREclairement();
    IBMRVitesseCourant: IBMRVitesseCourant = new IBMRVitesseCourant();
    IBMRVegetationAquatique: IBMRVegetationAquatique = new IBMRVegetationAquatique();

    IBMRTransectList: Transect[] = [];

    static mapFromJSON(json): IBMRUniteReleve {
        const ur = new IBMRUniteReleve();

        ur.Code = json.code;
        ur.Recouvrement = json.recouvrement;
        ur.Longueur = json.longueur;
        ur.Largeur = json.largeur;
        ur.SurfaceVegetalisee = json.surfaceVegetalisee;
        ur.AbondancePeriphyton = json.abondancePeriphyton;
        ur.TypeUnite = json.typeUnite;

        if (json.ibmrSubstrat)
            ur.IBMRSubstrat = IBMRSubstrat.mapFromJSON(json.ibmrSubstrat);
        if (json.ibmrProfondeur)
            ur.IBMRProfondeur = IBMRProfondeur.mapFromJSON(json.ibmrProfondeur);
        if (json.ibmrFaciesEcoulement)
            ur.IBMRFaciesEcoulement = IBMRFaciesEcoulement.mapFromJSON(json.ibmrFaciesEcoulement);
        if (json.ibmrEclairement)
            ur.IBMREclairement = IBMREclairement.mapFromJSON(json.ibmrEclairement);
        if (json.ibmrVitesseCourant)
            ur.IBMRVitesseCourant = IBMRVitesseCourant.mapFromJSON(json.ibmrVitesseCourant);
        if (json.ibmrVegetationAquatique)
            ur.IBMRVegetationAquatique = IBMRVegetationAquatique.mapFromJSON(json.ibmrVegetationAquatique);
        if (json.ibmrTransectList) {
            ur.IBMRTransectList = json.ibmrTransectList.map(item => Transect.mapFromJSON(item));
        }
        return ur;
    }
}